<template>
  <div class="loading abs-center"
       v-if="isLoading">
    <div class="loading-img"></div>
    <div class="loading-progress"
           v-if="isLoading" :style="{width:loadPercent+'%'}"></div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'loading',
  data() {
    return {
      show: true,
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => (state.mainLoad.isLoading),
      loadPercent: (state) => (state.mainLoad.loadPercent),
    }),
  },
};
</script>
<style lang="less" scoped>
.loading {
  width: 229px;
  height: 100px;
  z-index: 1000;
  &-img {
    background: url("~@/assets/images/logo_Ringier.png");
    width: 229px;
    height: 85px;
  }
  &-progress {
    background: white;
    width: 229px;
    height: 2px;
    margin-top: 5px;
    transition: all 1.6s;
  }
  .start {
    width: 226px;
  }
  .end {
    width: 226px;
    transition: all none;
  }
  .line-enter-active,
  .line-leave-active {
    transition: width 2.5s;
  }
  .line-enter, .line-leave-to /* .line-leave-active below version 2.1.8 */ {
    width: 0px;
  }
}
</style>
